import { render, staticRenderFns } from "./Reactions.vue?vue&type=template&id=156d7a84&scoped=true&"
import script from "./Reactions.vue?vue&type=script&lang=ts&"
export * from "./Reactions.vue?vue&type=script&lang=ts&"
import style0 from "./Reactions.vue?vue&type=style&index=0&id=156d7a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156d7a84",
  null
  
)

export default component.exports